<template>
  <div
      v-if="hasData"
      class="icon-cont"
      :class="readOnly ? 'read-only' : isSelected ? 'active':''"
      :title="channelData.label"
      @click.stop="(readOnly || isDisabled || isSelected) ? null : (showVerify = true)"
  >
    <component :is="svgIcon" :label="channelData.label"></component>
    <v-dialog v-model="showVerify">
      <v-card class="confirmation-card">
        <v-card-title
            style="
              background-color: #1c6e59;
              color: white;
              letter-spacing: 0.03rem;
              height: 40px;
            "
            :style="
              $vuetify.breakpoint.xsOnly ? 'text-align: center !important;' : ''
            "
        >
          Assign "{{ channelData.label }}"?
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn plain @click="showVerify = false">Cancel</v-btn>
          <v-btn
              color="primary"
              @click="selectChannel"
          >
            Assign
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmDialog from "@/components/Default-Page-Components/modules/ConfirmDialog.vue";
import InputWrapper2 from "@/components/UI/InputWrapper2.vue";

export default {
  name: 'ChannelIcon',
  components: {InputWrapper2, ConfirmDialog},
  props: {
    channelData: {
      type: Object,
      default: () => ({
        id: null,
        name: '',
        value: '',
        description: '',
      })
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showVerify: false,
  }),
  computed: {
    hasData() {
      return !!this.channelData && !!this.channelData.name && (this.channelData.name.length > 0);
    },
    svgIcon() {
      switch (this.channelData.name) {
        case 'sms':
          // return () => import('./ChannelIcons/SMS.vue');
          return () => import('./ChannelIcons/SMS.vue');
        case 'whatsapp':
          return () => import('./ChannelIcons/WhatsApp.vue');
        case 'viber':
          return () => import('./ChannelIcons/Viber.vue');
        case 'telegram':
          return () => import('./ChannelIcons/Telegram.vue');
        case 'email':
          return () => import('./ChannelIcons/Email.vue');
        case 'slack':
          return () => import('./ChannelIcons/Slack.vue');
        default:
          return () => import('./ChannelIcons/Default.vue');
      }
    }
  },
  methods: {
    /**
     * Select the target channel
     * - emit "assign" event to parent and close the confirmation dialog
     */
    selectChannel() {
      this.$emit('assign');
      this.showVerify = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-cont {
  height: 24px;
  width: 24px;
  margin: 4px;
  transition: all ease-in-out 0.3s;
  cursor: pointer;

  svg {
    height: 24px;
    width: 24px;
  }

  &.active {
    cursor: default;
    opacity: 0.8;
  }
}

.main-dark {
  .icon-cont {
    & > svg {
      //fill: #338569;
      fill: #9f9f9f;
    }

    &:not(.read-only) {
      &:hover {
        fill: #ffffff;

        & > svg {
          //fill: #338569;
          fill: #ffffff;
        }
      }
    }

    &.active {
      & svg {
        fill: #07bb7e;
      }
    }
  }
}

.main-light {
  .icon-cont {
    & > svg {
      fill: #25624c;
    }

    &:hover {
      //fill: #009d61;
      fill: red;
    }

    &.active {
      fill: #543e77;
    }
  }
}

.confirmation-card {
  max-width: 340px;
  margin: 0 auto;
}

.read-only {
  & * {
    cursor: default !important;
    color: unset !important;
  }

  .icon-cont:not(.read-only) {
    & > svg {
      fill: #25624c !important;
    }
  }
}
</style>